import React, { useState } from "react";
import faqImg from "../Assets/fAQ.png"; // apni image yaha use karo

const NeedHelp = () => {
  const [activeTab, setActiveTab] = useState("questions");

  return (
    <div className="w-full bg-gray-50 rounded-2xl p-6 md:p-10">
      {/* HEADER */}
      <h2 className="text-lg font-semibold text-teal-700 mb-6">
        Need Help
      </h2>

      {/* TABS */}
      <div className="flex justify-center gap-10 mb-10">
        <button
          onClick={() => setActiveTab("questions")}
          className={`pb-2 text-base font-medium ${
            activeTab === "questions"
              ? "text-teal-700 border-b-2 border-teal-700"
              : "text-gray-400"
          }`}
        >
          Questions
        </button>

        <button
          onClick={() => setActiveTab("answers")}
          className={`pb-2 text-base font-medium ${
            activeTab === "answers"
              ? "text-teal-700 border-b-2 border-teal-700"
              : "text-gray-400"
          }`}
        >
          Answers
        </button>
      </div>

      {/* CONTENT */}
      {activeTab === "questions" && (
        <div className="flex flex-col items-center text-center">
          <img
            src={faqImg}
            alt="FAQ"
            className="w-64 md:w-80 mb-6"
          />

          <h3 className="text-lg md:text-xl font-semibold text-teal-700 mb-2">
            Hey! Right now you haven't asked any questions.
          </h3>

          <p className="text-sm md:text-base text-gray-600 max-w-xl">
            Ask your questions about any product and get your answers
            from Doctors, Experts and the Cosmic Careeness Community.
          </p>
        </div>
      )}

      {activeTab === "answers" && (
        <div className="flex flex-col items-center text-center py-20">
          <p className="text-gray-500 text-base">
            You don’t have any answers yet.
          </p>
        </div>
      )}
    </div>
  );
};

export default NeedHelp;
